import {scaledValue} from "../../performance/CompactPerformanceValue";
import React from "react";
import styled from "styled-components";
import {numberToFormattedPercent} from "../../performance/PercentageChange";

const ChangeContainer = styled.div`
    display: flex;
    font-size: 12px;
    line-height: 22px;
`;

const InvestmentChanged = styled.div`
    margin-right: 3px;
`;

const ActualPercentage = styled.div`
    margin-right: 3px;
    font-weight: bold;
`;

const FromText = styled.div`
    margin-right: 3px;
`;

const ToText = styled.div`
    margin-left: 3px;
    margin-right: 3px;
`;

const Amounts = styled.div`
    font-weight: bold;
`;

export const InvestmentChange = ({amountBefore, amountAfter, actualUpdatePercent}) => {
    if (amountBefore === amountAfter) {
        return (
            <ChangeContainer>
                <InvestmentChanged>Investment unchanged</InvestmentChanged>
                <FromText>: </FromText>
                <Amounts>{scaledValue(amountBefore)}</Amounts>
            </ChangeContainer>
        );
    }
    else {
        return (
            <ChangeContainer>
                <InvestmentChanged>Investment</InvestmentChanged>
                <ActualPercentage>{numberToFormattedPercent(actualUpdatePercent)}</ActualPercentage>
                <FromText>: From</FromText>
                <Amounts>{scaledValue(amountBefore)}</Amounts>
                <ToText>to</ToText>
                <Amounts>{scaledValue(amountAfter)}</Amounts>
            </ChangeContainer>
        );
    }
};